import { Text } from "@/components/ui/baseUi/text"
import type { MediaItem } from "@/modules/common/media/mediaTypes"
import { cn } from "@/modules/lib/utils"
import type { SessionMediaItemEntity } from "@/modules/sessions/entities/sessionBlockMediaEntity"
import { VideoPlayer } from "@modules/common/media/components/videoPlayer"
import { word } from "@modules/core/utils/i18n"

type MediaDetailsVideoProps = {
  media: SessionMediaItemEntity | MediaItem
  className?: string
} & React.ComponentProps<"div">

export function MediaDetailsVideo({ media, className, ...props }: MediaDetailsVideoProps) {
  return (
    <div className={cn(className)} {...props}>
      {media.url ? (
        <VideoPlayer
          options={{
            autoplay: false,
            controls: true,
            experimentalSvgIcons: true,
            sources: [
              {
                src: media.url,
                type: "application/x-mpegURL",
              },
            ],
          }}
          size="medium"
          className="overflow-hidden rounded-4xl"
        />
      ) : (
        <Text fontStyle="BM" className="wrap-break-word">
          {word("sessionForm.blocks.add_media.missing_error")}
        </Text>
      )}
    </div>
  )
}
